import { render } from "./NewPassword.vue?vue&type=template&id=27bac869"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"

import "./NewPassword.vue?vue&type=style&index=0&id=27bac869&lang=scss"
script.render = render

export default script